export * from './TeacherDetail';
